import { Code } from '#components/atoms/code/Code.tsx';
import { Snippet } from '#components/patterns/code/snippet/Snippet.tsx';
import type { HostNoun } from '#dn-types/host.ts';
import type { EnrollmentState } from '../types.ts';
import { dockerComposeFile } from './container-install.ts';
import { TokenStatus } from './token-instructions/TokenStatus.tsx';

type Props = {
  url?: string;
  hostNoun: HostNoun;
  enrollmentState: EnrollmentState;
};

export function DockerComposeInstructions({ url, enrollmentState, hostNoun }: Props) {
  return (
    <>
      <h2 className="h3">3. Create Compose file</h2>
      <p>
        Create a file named <Code>docker-compose.yaml</Code> with the contents:
      </p>
      <Snippet disabled={!enrollmentState.token || enrollmentState.isExpired} breakWord={true}>
        {dockerComposeFile(enrollmentState.token)}
      </Snippet>
      {url ?
        <p className="p-md mb-40">
          Learn more on{' '}
          <a className="a" href={url}>
            Docker Hub
          </a>
        </p>
      : null}
      <h2 className="h3">4. Run Docker Compose</h2>
      <Snippet breakWord={true} addPrompt={true}>
        docker compose up -d
      </Snippet>
      <TokenStatus
        hostNoun={hostNoun}
        enrollSuccessful={enrollmentState.enrollSuccessful}
        handleDone={enrollmentState.handleDone}
      />
    </>
  );
}
